import { JobOpeningIcon } from "../assets/svg/JobOpening";
import { DescriptionIcon } from "../assets/svg/DescriptionIcon";

export const campgainData = [
  {
    id: 1,
    campaignOwner: "John Doe",
    type: "Confrence",
    wb4you: "WB4YOU",
    status: "Pending",
    date: "12-03-2025",
    expectedRevenue: 5000,
    budgetCost: 1000,
    actualCost: 1200,
    numberSent: 300,
  },
  {
    id: 2,
    campaignOwner: "John Doe",
    type: "Webniar",
    wb4you: "WB4YOU",
    status: "Rejected",
    date: "12-03-2025",
    expectedRevenue: 5000,
    budgetCost: 1000,
    actualCost: 1200,
    numberSent: 300,
  },
  {
    id: 3,
    campaignOwner: "John Doe",
    type: "Public relations",
    wb4you: "WB4YOU",
    status: "Pending",
    date: "22-03-2025",
    expectedRevenue: 5000,
    budgetCost: 1000,
    actualCost: 1200,
    numberSent: 300,
  },
];


export const campgainTabsData = [
  { label: 'Campaign information', Icon: JobOpeningIcon },
  { label: 'Description information', Icon: DescriptionIcon },
];

export const   campaignDataName= ["Anish","Agrawal","John Doe"];
export const   campaignStatusName= ["Pending","Rejected","Pending"];
export const   campaignStatus= ["Pending","Rejected","Pending"];